module.exports = __webpack_public_path__ + "img/ZWF_Kadu_Larissa.fdbb684b.jpg";